module.exports = __webpack_public_path__ + "img/logo.fe994a7f.png";